<template>
  <div class="home">
    <HeroBlock :postcode="postcode" @submit="next" @toggleFixedPostcode="toggleFixedPostcode" />
    <SupplierRow />
    <HowItWorks />
    <TwoRowBlock />
    <AboutBlock />
    <CallBanner />
    <ProviderBlock />
    <FooterBlock />

    <transition name="slide-up">
      <BasicPostcodeInput
        v-show="showFixedPostcode"
        v-model="postcode"
        container
        fixed
        name="Postcode"
        placeholder="Enter your postcode"
        :icon="whitelabelIcon"
        :icon-hover="whitelabelIconHover"
        @submit="next"
      />
    </transition>
  </div>
</template>

<script>
import BasicPostcodeInput from '@mic/frontend/inputs/BasicPostcodeInput'
import HeroBlock from '@/components/home/HeroBlock'
import SupplierRow from '@/components/home/SupplierRow'
import HowItWorks from '@/components/home/HowItWorks'
import TwoRowBlock from '@/components/home/TwoRowBlock'
import AboutBlock from '@/components/home/AboutBlock'
import ProviderBlock from '@/components/home/ProviderBlock'
import CallBanner from '@/components/home/CallBanner'
import FooterBlock from '@/components/home/FooterBlock'
import CampaignServiceDevBox from '@mic/frontend/DevBox/CampaignServiceDevBox'
import ResponseTapDevBox from '@mic/frontend/DevBox/ResponseTapDevBox'

const whitelabel = require('../../whitelabel.config')

export default {
  name: 'Home',

  components: {
    HeroBlock,
    SupplierRow,
    HowItWorks,
    TwoRowBlock,
    AboutBlock,
    CallBanner,
    ProviderBlock,
    FooterBlock,
    BasicPostcodeInput
  },

  devBoxComponents: [
    CampaignServiceDevBox,
    ResponseTapDevBox
  ],

  data () {
    return {
      postcode: '',
      showFixedPostcode: false,
      whitelabelIcon: whitelabel[process.env.VUE_APP_BRAND].searchButtonIcon,
      whitelabelIconHover: whitelabel[process.env.VUE_APP_BRAND].searchButtonIconHover
    }
  },

  methods: {
    toggleFixedPostcode (value) {
      this.showFixedPostcode = value
    },
    next (postcode) {
      if (postcode) {
        this.postcode = postcode
        const url = `question/postcode?postcode=${postcode}`
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  padding-bottom: $spacing-80; /* 80px for fixed postcode input component height */

  @media (max-width: $screen-md) {
    padding-bottom: $spacing-64;
  }
}
</style>
